import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/medapps': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M118.3 238.4c3.5-12.5 6.9-33.6 13.2-33.6 8.3 1.8 9.6 23.4 18.6 36.6 4.6-23.5 5.3-85.1 14.1-86.7 9-0.7 19.7 66.5 22 77.5 9.9 4.1 48.9 6.6 48.9 6.6 1.9 7.3-24 7.6-40 7.8-4.6 14.8-5.4 27.7-11.4 28-4.7 0.2-8.2-28.8-17.5-49.6l-9.4 65.5c-4.4 13-15.5-22.5-21.9-39.3-3.3-0.1-62.4-1.6-47.6-7.8zM228 448h-136c-21.2 0-21.2-32 0-32h136c21.2 0 21.2 32 0 32zM204 512h-88c-21.2 0-21.2-32 0-32h88c21.2 0 21.2 32 0 32zM238.2 370.5c-3.6 21.3-36 15.5-32.6-5.1 3.6-21.2 5.6-40.6 15.3-58.6 32.6-60.3 66.1-95.5 66.1-151.6 0-67.9-57-123.2-127-123.2s-127 55.3-127 123.2c0 56.1 33.5 91.3 66.1 151.7 9.7 17.9 11.7 36.9 15.3 58.6 3.5 20.8-29.1 26.1-32.6 5.1-3.2-19.1-5.2-36.4-11.9-48.9-8-14.7-16.1-28.1-24-41-24.6-40.4-45.9-75.3-45.9-125.5 0-85.6 71.8-155.2 160-155.2s160 69.6 160 155.2c0 50.3-21.3 85.1-45.9 125.5-7.9 12.9-16.1 26.3-24 41-6.7 12.4-8.7 29.9-11.9 48.8z'
      }
    ]
  }
})
